<template>


	<el-container class="lables" style="width: 80%;margin-left: 10%;">
    <el-row style="margin-top: 49px;margin-right: 10px;">
      <el-button type="primary"  @click="upDingshi()">刷新页面</el-button>
    </el-row>
		<el-row  class="la-list">
			<el-col :span="15" class="first">
        <el-row style="text-align: center;font-size: 28px;">
        </el-row>
				<el-row class="lable-o-l lable-o-ls" v-for="(item,index) in list1" :key="index">
					<div class="lable-o" style="float: left;" @click="up(item.lid,item.numw)">
          {{item.name}}({{item.num}})
          </div>
          <div class="lable-o" style="float: left;">
          未更新({{item.numw}})
          </div>
				</el-row>
			</el-col>

		</el-row>

	</el-container>



</template>

<script>

  export default {
    data() {
      return {
        list1:[],


      };
    },
	created() {

	  this.loadData();

	},

	methods:{
    upDingshi(){
      this.loadData();
    },
    up(id,num){
      if(num > 0){
        alert('请等待更新完毕')
        return false
      }
      if(id == 0){
        alert('请勿更新兜底')
        return false
      }
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });

      axiosInstance({
      	method:'post',
      	url:'http://fencip.yoooooo.com/index.php/index/data/qredisUpdateAll',
      	params:{
          id:id

        }
      })
      .then(res=>{
        alert('更新成功')
        this.loadData();

      })
      .catch(err=>{

      });
    },
		loadData(){
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'get',
				params:{
					name:this.searchF
				},
				url:'http://fencip.yoooooo.com/index.php/index/data/qsredis'
			})
			.then(res=>{
				this.list1 = res.data.list1;


			})
			.catch(err=>{

			});
		},


	}


  }
</script>

<style>

	.content{

		width: 100%;
		height: 100%;
	}
	.centr{
		margin-top: 30%;
	}
	.centr img{
		width: 100px;
		height: 50px;
		margin-left: 35px;
	}

	.zhuyi{
		color: red;
    margin-left: 120px;
    font-size: 20px;
	}
	.butn{
		color: #F0F8FF;
		background: #FF9400;
		margin-right: 20px;
		border-radius: 5px;
		width: 50px;
	}
	.lables{

		background: #fff;
		padding-bottom: 35px;
	}
	.lables .la-list{
		margin-top: 50px;
		width: 100%;

	}
	.first{
		border: 1px solid #c6c6c6;
		height: 850px;
		overflow-y:scroll;
	}
	.first .el-row{
		margin: 20px 10% 20px 10%;
	}
	.search input{
		width: 95%;
		height: 20px;
		margin-bottom: 10px;
		margin-left: 2%;
	}
	.add{
		text-align: center;
		width: 96%;
		background: #c6c6c6;
		height: 22px;
		line-height: 22px;
		margin-left: 2%;
	}

	.lable-o{
		width: 47%;
		text-align: center;
		background: #c6c6c6;
		height: 30px;
		line-height: 30px;
		margin-bottom: 10px;
	}
	.lable-two{

		text-align: center;
		background: #c6c6c6;

		line-height: 30px;
		margin-bottom: 10px;
	}
	.choses{
		background: #f8f1da;
	}
	.chosess{
		background: #ff9400;
	}
	.right{
		float: right;
	}
	.left{
		float: left;
	}
	.two{
		border: 1px solid #c6c6c6;
		height: 850px;
		overflow-y:scroll;
	}
	.two .el-row{
		margin: 20px 10% 20px 10%;
	}
	.searchTsx{
		width: 30%;
		margin-left: 10%;
		height: 30px;
	}
  .s_or_x{
    width: 20%;
    height: 35px;
  }
	.lable-o-ls{
		border-bottom: 1px solid #c6c6c6;
	}
</style>



// WEBPACK FOOTER //
// src/components/main/qsredis.vue